<template>
    <div class="upload">
        <el-upload
                action="/admin/file/upload"
                name="file"
                class="avatar-uploader"
                ref="upload"
                :headers="{
                    Authorization: 'bearer ' + this.token,
                }"
                :data="{
                    ownId: this.ownerId || 0,
                    owner: this.owner,
                    uploadBatchId: 'res-' + new Date().getTime() + '' + Math.round(Math.random() * 100)
                }"
                :on-remove="onFileRemove"
                :on-success="onFileUploadSuccess"
                :on-preview="onFilePreView"
                :auto-upload="this.autoUpload"
                 :multiple="mode == 'card' ? true : false"
                :show-file-list="mode == 'list' ? true : false"
                :limit="limit || 3"
                :disabled="disabled"
                :on-exceed="onFileExceed"
                :file-list="localFileList"
                :on-change="onFileChange"
        >
            <div v-if="mode == 'list'">
                <el-button size="small">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="line-height: 1rem">{{this.description}}</div>
            </div>
            <div v-if="mode == 'card'">
                <img v-if="cardPic" :src="cardPic" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
        </el-upload>
    </div>
</template>
<script>
    import {mapActions, mapState} from "vuex";
    export default {
        data: function () {
            return {
                count: 0,
                fileList: [],
                cardPic: null
            };
        },
        model: {
          prop: 'modelVal',
          event: 'change'
        },
        computed: {
            ...mapState("auth", ["token", "email"]),
            localFileList: function () {
                return this.fileList
                    ? this.fileList.map(e => ({name: e.fullName, url: "/admin/file/download?fileId=" + e.id,fileId: e.id}))
                    : [];
            },
            isAutoUpload: function () {
                return this.ownerId ? true : false;
            }
        },
        props: {
            owner: {type: String},
            description: String,
            onUploadSuccess: Function,
            onRemoveSuccess: Function,
            onFileComplete: Function,
            ownerId: null,
            disabled: Boolean,
            limit: Number,
            onFileChangeSuccess: Function,
            autoUpload: {type: Boolean, required: true},
            mode: {type: String, default: "list"},
            modelVal: String
        },
        watch: {
            modelVal: function () {
                this.cardPic = this.modelVal;
            },
            cardPic: function () {
                this.$emit('change', this.cardPic);
            }
        },
        created: function () {
        },
        mounted: function () {
        },
        methods: {
            onFileUploadSuccess: function (response, file, fileList) {
                if(response.success) {
                    console.log(response.data)
                    this.fileList = [response.data];
                    this.cardPic = response.data;
                    if(this.onUploadSuccess) this.onUploadSuccess(response.data);
                    if(this.onFileComplete) this.onFileCompleteResult(fileList)
                } else {
                    this.$message.error(response.msg);
                }
            },
            onFileRemove: function (file, fileList) {
                if(file.status === "ready" || file.status === "success"){
                    if(this.onRemoveSuccess) this.onRemoveSuccess(file.response ? file.response.data.id : file.fileId);
                }
            },
            onFileExceed: function () {
                this.$message.warning('超过上传个数限制！')
            },
            onFilePreView: function (file) {
                window.open(file.url);
            },
            submitUpload() {
                this.$refs['upload'].submit();
            },
            onFileChange: function(file, fileList){
                if(file.status === "ready" || file.status === "success"){
                    if(this.onFileChangeSuccess) this.onFileChangeSuccess(file.raw);
                }
            },
            onFileCompleteResult: function (fileList) {
                this.count++;
                if(this.count === fileList.length-this.fileList.length){
                     this.onFileComplete()
                     this.count = 0
                }
            }
        }
    }
</script>
